export const subAccountRoutes = {
  default: 'accounts_list_v2',
  dashboard: 'accounts_list_v2_dashboard',
  schedules: 'accounts_list_v2_schedules',
  bulkActionHistory: 'account_bulk_action_history',
  accounts:{
    default:'accounts_list',
    add:'account_add',
    search:'account_add_map',
    detail:'account_detail',
  }
}
